/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SearchModal.Item.vue?vue&type=template&id=20c13ac4"
import script from "./SearchModal.Item.vue?vue&type=script&lang=js"
export * from "./SearchModal.Item.vue?vue&type=script&lang=js"
import style0 from "./SearchModal.Item.vue?vue&type=style&index=0&id=20c13ac4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports